import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWebhooksQueryVariables = Types.Exact<{
  ownerUserId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  ownerTeamId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;

export type GetWebhooksQuery = {
  __typename?: 'Query';
  webhooks: {
    __typename?: 'WebhookConnection';
    edges: Array<{
      __typename?: 'WebhookEdge';
      node: {
        __typename?: 'Webhook';
        id: any;
        ownerUserId?: any | null;
        ownerTeamId?: any | null;
        type: Types.WebhookType;
        label: string;
        url: string;
        method: string;
        createdAt: any;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export const GetWebhooksDocument = gql`
  query GetWebhooks($ownerUserId: UUID, $ownerTeamId: UUID) {
    webhooks(ownerUserId: $ownerUserId, ownerTeamId: $ownerTeamId) {
      edges {
        node {
          id
          ownerUserId
          ownerTeamId
          type
          label
          url
          method
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetWebhooksQuery__
 *
 * To run a query within a React component, call `useGetWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebhooksQuery({
 *   variables: {
 *      ownerUserId: // value for 'ownerUserId'
 *      ownerTeamId: // value for 'ownerTeamId'
 *   },
 * });
 */
export function useGetWebhooksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWebhooksQuery,
    GetWebhooksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWebhooksQuery, GetWebhooksQueryVariables>(
    GetWebhooksDocument,
    options,
  );
}
export function useGetWebhooksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWebhooksQuery,
    GetWebhooksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWebhooksQuery, GetWebhooksQueryVariables>(
    GetWebhooksDocument,
    options,
  );
}
export function useGetWebhooksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetWebhooksQuery,
        GetWebhooksQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWebhooksQuery, GetWebhooksQueryVariables>(
    GetWebhooksDocument,
    options,
  );
}
export type GetWebhooksQueryHookResult = ReturnType<typeof useGetWebhooksQuery>;
export type GetWebhooksLazyQueryHookResult = ReturnType<
  typeof useGetWebhooksLazyQuery
>;
export type GetWebhooksSuspenseQueryHookResult = ReturnType<
  typeof useGetWebhooksSuspenseQuery
>;
export type GetWebhooksQueryResult = Apollo.QueryResult<
  GetWebhooksQuery,
  GetWebhooksQueryVariables
>;
